module.exports = __webpack_public_path__ + "static/day07-843fdff051083e5a1d786f212c718254.png";